import { Injectable } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { PersoOffer } from 'app/shared/models/class/basket/basketList';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Tag } from 'app/shared/models/class/tags/tag';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {

  themeDemo$ = new BehaviorSubject<boolean>(false);

  titleHomePage = new BehaviorSubject<string>('Trouver une activité');
  titleAdminOffer = new BehaviorSubject<string>('Liste des offres');
  titleWelcome$ = new BehaviorSubject<string>('Nautisme et plaisance en Hauts-de-France');
  titleOfferPriority$ = new BehaviorSubject<string>('Gestion des offres prioritaires');
  parametersOfferStringify$ = new BehaviorSubject<string>('');
  actionFormOfferAdmin = new BehaviorSubject<string>('');
  clubCodePriorityOffer$ = new BehaviorSubject<string>('');
  tabActiveOfferEdit$ = new BehaviorSubject<string>('description');
  actionTabSession$ = new BehaviorSubject<string>('edit');
  clubActivePracticePlace$ = new BehaviorSubject<string>(null);
  clubActiveDiscount$ = new BehaviorSubject<string>(null);
  clubActiveResources$ = new BehaviorSubject<string>(null);
  clubActiveParameters$ = new BehaviorSubject<string>(null);


  isAdmin = new BehaviorSubject<boolean>(false);
  popUpSignIn = new BehaviorSubject<boolean>(false);
  popUpShop = new BehaviorSubject<boolean>(false);
  isConnectUser = new BehaviorSubject<boolean>(false);
  isConnectAdmin = new BehaviorSubject<boolean>(false);
  showTableOfferAdmin = new BehaviorSubject<boolean>(true);
  showAddSession = new BehaviorSubject<boolean>(false);
  showEditStructure = new BehaviorSubject<boolean>(false);
  showEditParams = new BehaviorSubject<boolean>(false);
  loadingOfferHome$ = new BehaviorSubject<boolean>(false);
  paramsOfferIsComplete$ = new BehaviorSubject<boolean>(false);
  paramsOfferRequiredIsComplete$ = new BehaviorSubject<boolean>(false);
  confirmParamsOfferCustomized$ = new BehaviorSubject<boolean>(false);
  bookedOpen$ = new BehaviorSubject<boolean>(false);
  updateBooking$ = new BehaviorSubject<boolean>(false);
  updatePracticePlace$ = new BehaviorSubject<boolean>(false);
  updateRessources$ = new BehaviorSubject<boolean>(false);
  updatePromoCode$ = new BehaviorSubject<boolean>(false);
  updateOfferPriority$ = new BehaviorSubject<boolean>(false);
  showDetailsClubPriority$ = new BehaviorSubject<boolean>(false);
  openSearchOffer$ = new Subject<boolean>();
  showTagSearch$ = new BehaviorSubject<boolean>(false);
  updateBasketInMobile$ = new BehaviorSubject<boolean>(false);
  showIcons$ = new BehaviorSubject<boolean>(false);
  afterUpdateTraineesInBasket$ = new BehaviorSubject<boolean>(false);
  destroyComponent$ = new BehaviorSubject<boolean>(false);
  updatedParameters$ = new BehaviorSubject<boolean>(false);

  myWishes = new BehaviorSubject<FullOffer[]>([]);
  myShoppingBag = new BehaviorSubject<FullOffer[]>([]);
  tagSelectedAddOffer = new BehaviorSubject<Tag[]>([]);
  tagSelected$ = new BehaviorSubject<Tag[]>([]);
  clubPreview = new BehaviorSubject<ClubDetails>(null);
  offersHome$ = new BehaviorSubject<FullOffer[]>([]);
  jsonResauxSocial$ = new BehaviorSubject<object>({});
  expandedElement$ = new BehaviorSubject<any>(null);
  valueFilterPopUpSelected$ = new BehaviorSubject<FilterPopUpTable[]>([]);
  valueFilterPopUpChoice$ = new BehaviorSubject<string[]>([]);
  customizeParametersForm$ = new BehaviorSubject<PersoOffer>(null);
  dataFilteredTable$ = new BehaviorSubject<any[]>([]);
  offerPreview = new BehaviorSubject<FullOffer>(null);
  clubPriorityOffer$ = new BehaviorSubject<ClubDetails>(null);
  offerToEdit = new Subject<FullOffer>();

  valueInputSearchOfferAdminTable = new Subject<string>();
  actionFormOfferAdminSub$ = new Subject<string>();
  valueFilterPracticePlace$ = new Subject<string>();
  valueFilterDiscount$ = new Subject<string>();
  valueFilterOfferPriority$ = new Subject<string>();
  valueFilterResource$ = new Subject<string>();
  valueFilterParameter$ = new Subject<string>();
  tabHome$ = new Subject<string>();


  offerPreviewSub = new Subject<FullOffer>();

  constructor() { }

  resetPopUp(): void {
    this.popUpShop.next(false);
    this.popUpSignIn.next(false);

    const column = ['popup_filter_offer_name', 'popup_filter_offer_price', 'popup_filter_booked_name', 'popup_filter_booked_status', 'popup_filter_planning_name', 'popup_filter_planning_status', 'popup_filter_planning_ressources', 'popup_filter_booked_closed_offername', 'popup_filter_booked_closed_status', 'popup_filter_booked_user_offername', 'popup_filter_booked_user_status', 'popup_filter_offer_inprogress_offername', 'popup_filter_offer_inprogress_bookingGlobalStatus', 'popup_filter_offer_inprogress_bookingAmount', 'popup_filter_modification_isCustomerNotified'];

    column.forEach(col => {
      const popup = document.getElementById(col);
      if (popup) {
        popup.style.display = 'none';
      }
    });
  }

}
